export const PostSubmissionLoadingViewStyles = {
  container: 'flex flex-1 flex-col justify-center content-center mx-2',
  spinner: 'mt-12 mb-10',
  label: 'text-center'
}
